// Shared sub-components matching the real app's exact colors/structure

const SidebarSection = ({ title }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 10px 5px" }}>
    <span style={{ borderLeft: "2px solid #1a73e8", paddingLeft: "7px", fontSize: "7px", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.07em", color: "#424242" }}>
      {title}
    </span>
  </div>
);

const SidebarItem = ({ label, icon, active, indent }) => (
  <div style={{
    display: "flex", alignItems: "center", gap: "7px",
    padding: indent ? "5px 8px 5px 20px" : "5px 8px 5px 12px",
    marginRight: "6px",
    borderRadius: "6px",
    fontSize: "9px",
    fontWeight: active ? 700 : 500,
    color: active ? "#1a73e8" : "#424242",
    background: active ? "#e8f0fe" : "transparent",
  }}>
    <span style={{ width: "12px", textAlign: "center", fontSize: "9px", color: active ? "#1a73e8" : "#9e9e9e", flexShrink: 0 }}>{icon}</span>
    {label}
  </div>
);

const AppSidebar = ({ activeSection, activeItem }) => (
  <div style={{ width: "130px", flexShrink: 0, background: "#fff", boxShadow: "2px 0 8px rgba(0,0,0,0.06)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
    {/* Logo bar */}
    <div style={{ background: "linear-gradient(135deg, #1a237e 0%, #1a73e8 100%)", padding: "10px 12px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <div style={{ width: "16px", height: "16px", borderRadius: "4px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ color: "#fff", fontSize: "8px", fontWeight: 900 }}>FP</span>
        </div>
        <span style={{ color: "#fff", fontSize: "9px", fontWeight: 700, opacity: 0.9 }}>FreelancersPlace</span>
      </div>
    </div>
    {/* User panel */}
    <div style={{ margin: "8px 6px", padding: "8px 8px", background: "linear-gradient(135deg, #e8f0fe 0%, #f3e8ff 100%)", borderRadius: "8px", display: "flex", alignItems: "center", gap: "7px" }}>
      <div style={{ width: "24px", height: "24px", borderRadius: "50%", background: "#1a73e8", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: "9px", flexShrink: 0 }}>F</div>
      <div>
        <div style={{ fontSize: "7px", color: "#9e9e9e", fontWeight: 500 }}>Welcome back</div>
        <div style={{ fontSize: "9px", fontWeight: 700, color: "#212121" }}>Felix</div>
      </div>
    </div>
    {/* Nav */}
    <div style={{ flex: 1, overflow: "hidden", padding: "0 0 8px" }}>
      {/* Dashboard */}
      <SidebarItem label="Dashboard" icon="⬛" active={activeItem === "Dashboard"} />
      <SidebarSection title="Finance" />
      <SidebarItem label="Outgoing" icon="▶" active={activeItem === "Outgoing"} />
      <SidebarItem label="Incoming" icon="◀" active={activeItem === "Incoming"} />
      <SidebarItem label="Revenue" icon="📈" active={activeItem === "Revenue"} />
      <SidebarSection title="CRM" />
      <SidebarItem label="Projects" icon="⬛" active={activeItem === "Projects" && activeSection === "crm"} />
      <SidebarItem label="Contacts" icon="👥" active={false} />
      <SidebarItem label="Companies" icon="🏢" active={activeItem === "Companies"} indent />
      <SidebarItem label="People" icon="👤" active={activeItem === "People"} indent />
      <SidebarSection title="Projects" />
      <SidebarItem label="Overview" icon="📁" active={activeItem === "Overview"} />
      <SidebarItem label="Tickets" icon="🎫" active={activeItem === "Tickets"} />
    </div>
  </div>
);

const TopBar = ({ title, badge, action }) => (
  <div style={{ background: "#fff", borderBottom: "1px solid #f0f0f0", padding: "8px 14px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <span style={{ fontSize: "11px", color: "#bdbdbd" }}>≡</span>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {badge && <span style={{ background: "#e8f0fe", color: "#1a73e8", borderRadius: "6px", padding: "2px 8px", fontSize: "8px", fontWeight: 700 }}>{badge}</span>}
        <span style={{ fontWeight: 700, fontSize: "11px", color: "#212121" }}>{title}</span>
      </div>
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      {action && <div style={{ background: "#1a73e8", color: "#fff", borderRadius: "6px", padding: "3px 10px", fontSize: "8px", fontWeight: 700 }}>{action}</div>}
      <div style={{ width: "24px", height: "24px", borderRadius: "50%", background: "#1a73e8", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "8px", fontWeight: 700 }}>F</div>
    </div>
  </div>
);

const ContentCard = ({ title, action, children }) => (
  <div style={{ background: "#fff", borderRadius: "10px", boxShadow: "0 2px 10px rgba(0,0,0,0.07)", border: "1px solid #f0f0f0", overflow: "hidden", margin: "10px 12px" }}>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", borderBottom: "1px solid #f5f5f5" }}>
      <span style={{ fontWeight: 700, fontSize: "10px", color: "#212121" }}>{title}</span>
      {action && <div style={{ background: "#1a73e8", color: "#fff", borderRadius: "6px", padding: "2px 9px", fontSize: "8px", fontWeight: 700 }}>{action}</div>}
    </div>
    {children}
  </div>
);

const Row = ({ cols, even }) => (
  <div style={{ display: "grid", gridTemplateColumns: cols.map(c => c.w || "1fr").join(" "), padding: "6px 14px", borderBottom: "1px solid #f5f7fb", alignItems: "center", background: even ? "#fafbfc" : "#fff" }}>
    {cols.map((c, i) => (
      <div key={i} style={{ fontSize: "9px", ...c.style }}>
        {c.badge
          ? <span style={{ background: c.badge.bg, color: c.badge.c, borderRadius: "8px", padding: "1px 7px", fontSize: "8px", fontWeight: 700 }}>{c.badge.label}</span>
          : c.avatar
            ? <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <div style={{ width: "18px", height: "18px", borderRadius: c.avatar.round ? "50%" : "5px", background: c.avatar.bg + "33", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <span style={{ fontSize: "7px", fontWeight: 800, color: c.avatar.bg }}>{c.avatar.letter}</span>
                </div>
                <div>
                  <div style={{ fontWeight: 700, color: "#212121", fontSize: "9px" }}>{c.text}</div>
                  {c.sub && <div style={{ color: "#9e9e9e", fontSize: "7px" }}>{c.sub}</div>}
                </div>
              </div>
            : c.bar
              ? <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <div style={{ flex: 1, background: "#eef0f4", borderRadius: "3px", height: "4px" }}>
                    <div style={{ width: `${c.bar}%`, height: "100%", background: c.bar === 100 ? "#9e9e9e" : "#1a73e8", borderRadius: "3px" }} />
                  </div>
                  <span style={{ fontSize: "8px", color: "#9e9e9e" }}>{c.bar}%</span>
                </div>
              : <span style={{ color: c.muted ? "#9e9e9e" : "#212121", fontWeight: c.bold ? 700 : 400, fontFamily: c.mono ? "monospace" : "inherit" }}>{c.text}</span>
        }
      </div>
    ))}
  </div>
);

const ColHeaders = ({ labels }) => (
  <div style={{ display: "grid", gridTemplateColumns: labels.map(l => l.w || "1fr").join(" "), padding: "4px 14px", background: "#f8f9fb", borderBottom: "1px solid #f0f2f5" }}>
    {labels.map(({ label }) => (
      <span key={label} style={{ fontSize: "7px", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
    ))}
  </div>
);

const BrowserFrame = ({ children }) => (
  <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif", borderRadius: "10px", overflow: "hidden", boxShadow: "0 8px 40px rgba(0,0,0,0.15)", border: "1px solid #e0e0e0" }}>
    <div style={{ background: "#f0f0f0", padding: "7px 12px", display: "flex", alignItems: "center", gap: "5px" }}>
      <span style={{ width: "9px", height: "9px", borderRadius: "50%", background: "#ff5f57", display: "inline-block" }} />
      <span style={{ width: "9px", height: "9px", borderRadius: "50%", background: "#febc2e", display: "inline-block" }} />
      <span style={{ width: "9px", height: "9px", borderRadius: "50%", background: "#28c840", display: "inline-block" }} />
      <div style={{ flex: 1, background: "#fff", borderRadius: "4px", margin: "0 8px", padding: "3px 10px", color: "#999", fontSize: "8px", border: "1px solid #e0e0e0" }}>
        app.freelancersplace.net
      </div>
    </div>
    <div style={{ display: "flex", height: "260px" }}>
      {children}
    </div>
  </div>
);

// ── Main dashboard mock (for Welcome hero) ────────────────────────────────────
export const MockMainDashboard = () => (
  <BrowserFrame>
    <AppSidebar activeSection="dashboard" activeItem="Dashboard" />
    <div style={{ flex: 1, background: "#f5f7fa", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <TopBar title="Dashboard" />
      <div style={{ flex: 1, overflow: "hidden", padding: "4px 0" }}>
        {/* Stat cards */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px", margin: "8px 12px" }}>
          {[
            { label: "Open Invoices", val: "€ 12,400", c: "#1a73e8", bg: "#e8f0fe" },
            { label: "Active Projects", val: "6", c: "#2e7d32", bg: "#e6f4ea" },
            { label: "Hours This Month", val: "84 h", c: "#f57c00", bg: "#fff8e1" },
          ].map(({ label, val, c, bg }) => (
            <div key={label} style={{ background: "#fff", borderRadius: "8px", boxShadow: "0 1px 6px rgba(0,0,0,0.07)", padding: "10px 10px 8px", border: "1px solid #f0f0f0" }}>
              <div style={{ fontSize: "7px", color: "#9e9e9e", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "4px" }}>{label}</div>
              <div style={{ fontSize: "16px", fontWeight: 800, color: c }}>{val}</div>
            </div>
          ))}
        </div>
        <ContentCard title="Recent Activity">
          {[
            { label: "INV-2025-042 paid", sub: "Acme Corp · € 4,200",    dot: "#34a853" },
            { label: "New project started", sub: "Website Redesign",       dot: "#1a73e8" },
            { label: "Follow-up due",       sub: "Sarah Chen · CRM",       dot: "#f57c00" },
            { label: "Timesheet submitted",  sub: "Studio Inc · April",    dot: "#9e9e9e" },
          ].map(({ label, sub, dot }, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "6px 14px", borderBottom: i < 3 ? "1px solid #f5f7fb" : "none" }}>
              <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: dot, flexShrink: 0 }} />
              <div>
                <div style={{ fontSize: "9px", fontWeight: 600, color: "#212121" }}>{label}</div>
                <div style={{ fontSize: "8px", color: "#9e9e9e" }}>{sub}</div>
              </div>
            </div>
          ))}
        </ContentCard>
      </div>
    </div>
  </BrowserFrame>
);

// ── Billing mock ──────────────────────────────────────────────────────────────
const invoices = [
  { num: "INV-2025-042", client: "Acme Corp",  amt: "€ 4,200", badge: { bg: "#e6f4ea", c: "#2e7d32", label: "Paid"    } },
  { num: "INV-2025-041", client: "Studio Inc", amt: "€ 1,800", badge: { bg: "#fff8e1", c: "#f57c00", label: "Pending" } },
  { num: "INV-2025-040", client: "TechGmbH",   amt: "€ 3,500", badge: { bg: "#fce8e6", c: "#c62828", label: "Overdue" } },
  { num: "INV-2025-039", client: "Freelance",  amt: "€   900", badge: { bg: "#e6f4ea", c: "#2e7d32", label: "Paid"    } },
  { num: "INV-2025-038", client: "Bauer & Co", amt: "€ 2,100", badge: { bg: "#fff8e1", c: "#f57c00", label: "Pending" } },
];

export const MockBillingDashboard = () => (
  <BrowserFrame>
    <AppSidebar activeSection="finance" activeItem="Outgoing" />
    <div style={{ flex: 1, background: "#f5f7fa", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <TopBar title="Outgoing Bills" />
      <div style={{ flex: 1, overflow: "hidden" }}>
        {/* Summary strip */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px", margin: "8px 12px 4px" }}>
          {[
            { label: "This Month", val: "€ 8,100", c: "#1e2432" },
            { label: "Pending",    val: "€ 3,900", c: "#f57c00" },
            { label: "Overdue",    val: "€ 3,500", c: "#c62828" },
          ].map(({ label, val, c }) => (
            <div key={label} style={{ background: "#fff", borderRadius: "8px", boxShadow: "0 1px 6px rgba(0,0,0,0.07)", padding: "8px 10px", border: "1px solid #f0f0f0" }}>
              <div style={{ fontSize: "7px", color: "#9e9e9e", fontWeight: 600, textTransform: "uppercase", marginBottom: "3px" }}>{label}</div>
              <div style={{ fontSize: "14px", fontWeight: 800, color: c }}>{val}</div>
            </div>
          ))}
        </div>
        <ContentCard title="Bills" action="+ New">
          <ColHeaders labels={[{ label: "Number", w: "100px" }, { label: "Client" }, { label: "Amount", w: "70px" }, { label: "Status", w: "60px" }]} />
          {invoices.map((inv, i) => (
            <Row key={i} even={i % 2 !== 0} cols={[
              { text: inv.num,    w: "100px", muted: true, mono: true },
              { text: inv.client, bold: true },
              { text: inv.amt,    w: "70px",  bold: true },
              { badge: inv.badge, w: "60px" },
            ]} />
          ))}
        </ContentCard>
      </div>
    </div>
  </BrowserFrame>
);

// ── Projects mock ─────────────────────────────────────────────────────────────
const projects = [
  { name: "Website Redesign", client: "Acme Corp",  pct: 78,  budget: "€ 6,400", dot: "#1a73e8", status: { bg: "#e8f0fe", c: "#1a73e8", label: "Active" } },
  { name: "Mobile App Beta",  client: "Studio Inc", pct: 42,  budget: "€ 8,500", dot: "#34a853", status: { bg: "#e8f0fe", c: "#1a73e8", label: "Active" } },
  { name: "Brand Identity",   client: "TechGmbH",   pct: 100, budget: "€ 2,200", dot: "#9e9e9e", status: { bg: "#f5f5f5", c: "#9e9e9e", label: "Done"   } },
  { name: "SEO Consulting",   client: "Bauer & Co", pct: 20,  budget: "€ 1,800", dot: "#fbbc04", status: { bg: "#e8f0fe", c: "#1a73e8", label: "Active" } },
];

export const MockProjectsDashboard = () => (
  <BrowserFrame>
    <AppSidebar activeSection="projects" activeItem="Overview" />
    <div style={{ flex: 1, background: "#f5f7fa", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <TopBar title="Projects" action="+ New" />
      <div style={{ flex: 1, overflow: "hidden" }}>
        <ContentCard title="Active Projects">
          <ColHeaders labels={[{ label: "Project" }, { label: "Progress", w: "90px" }, { label: "Budget", w: "65px" }, { label: "Status", w: "55px" }]} />
          {projects.map((p, i) => (
            <Row key={i} even={i % 2 !== 0} cols={[
              { avatar: { letter: p.name[0], bg: p.dot, round: false }, text: p.name, sub: p.client },
              { bar: p.pct, w: "90px" },
              { text: p.budget, w: "65px", bold: true },
              { badge: p.status, w: "55px" },
            ]} />
          ))}
        </ContentCard>
      </div>
    </div>
  </BrowserFrame>
);

// ── Time tracking mock ────────────────────────────────────────────────────────
const timeEntries = [
  { project: "Website Redesign", task: "UI Design",       hours: "3:30", date: "Today",    dot: "#1a73e8" },
  { project: "Mobile App Beta",  task: "API Integration", hours: "5:00", date: "Today",    dot: "#34a853" },
  { project: "Website Redesign", task: "Code Review",     hours: "1:15", date: "Yesterday",dot: "#1a73e8" },
  { project: "SEO Consulting",   task: "Keyword Research",hours: "2:45", date: "Yesterday",dot: "#fbbc04" },
  { project: "Brand Identity",   task: "Logo Finalization",hours:"4:00", date: "Mon",      dot: "#9e9e9e" },
];

export const MockTimetracking = () => (
  <BrowserFrame>
    <AppSidebar activeSection="projects" activeItem="Tickets" />
    <div style={{ flex: 1, background: "#f5f7fa", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <TopBar title="Time Tracking" action="+ Log Time" />
      <div style={{ flex: 1, overflow: "hidden" }}>
        {/* Week total */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px", margin: "8px 12px 4px" }}>
          {[
            { label: "This Week", val: "16:30 h", c: "#1a73e8" },
            { label: "This Month", val: "84:15 h", c: "#212121" },
            { label: "Billable", val: "79:00 h", c: "#2e7d32" },
          ].map(({ label, val, c }) => (
            <div key={label} style={{ background: "#fff", borderRadius: "8px", boxShadow: "0 1px 6px rgba(0,0,0,0.07)", padding: "8px 10px", border: "1px solid #f0f0f0" }}>
              <div style={{ fontSize: "7px", color: "#9e9e9e", fontWeight: 600, textTransform: "uppercase", marginBottom: "3px" }}>{label}</div>
              <div style={{ fontSize: "14px", fontWeight: 800, color: c }}>{val}</div>
            </div>
          ))}
        </div>
        <ContentCard title="Recent Entries">
          <ColHeaders labels={[{ label: "Project" }, { label: "Task" }, { label: "Hours", w: "50px" }, { label: "Date", w: "65px" }]} />
          {timeEntries.map((e, i) => (
            <Row key={i} even={i % 2 !== 0} cols={[
              { avatar: { letter: e.project[0], bg: e.dot, round: false }, text: e.project, sub: "" },
              { text: e.task, muted: true },
              { text: e.hours, w: "50px", bold: true },
              { text: e.date, w: "65px", muted: true },
            ]} />
          ))}
        </ContentCard>
      </div>
    </div>
  </BrowserFrame>
);

// ── Profiles mock ─────────────────────────────────────────────────────────────
const profiles = [
  { name: "Full Stack Dev",      template: "Tech",       complete: 95, badge: { bg: "#e6f4ea", c: "#2e7d32", label: "Active"  }, dot: "#1a73e8" },
  { name: "React Specialist",    template: "Tech",       complete: 88, badge: { bg: "#e8f0fe", c: "#1a73e8", label: "Draft"   }, dot: "#34a853" },
  { name: "Freelance Consultant",template: "Consulting", complete: 72, badge: { bg: "#e8f0fe", c: "#1a73e8", label: "Draft"   }, dot: "#fbbc04" },
  { name: "Senior Engineer",     template: "Classic",    complete: 100,badge: { bg: "#e6f4ea", c: "#2e7d32", label: "Active"  }, dot: "#9e9e9e" },
];

export const MockProfilesDashboard = () => (
  <BrowserFrame>
    <AppSidebar activeSection="profiles" activeItem="Dashboard" />
    <div style={{ flex: 1, background: "#f5f7fa", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <TopBar title="My Profiles" action="+ New Profile" />
      <div style={{ flex: 1, overflow: "hidden" }}>
        <ContentCard title="Freelancer Profiles">
          <ColHeaders labels={[{ label: "Profile Name" }, { label: "Template", w: "75px" }, { label: "Complete", w: "80px" }, { label: "Status", w: "60px" }]} />
          {profiles.map((p, i) => (
            <Row key={i} even={i % 2 !== 0} cols={[
              { avatar: { letter: p.name[0], bg: p.dot, round: false }, text: p.name },
              { text: p.template, w: "75px", muted: true },
              { bar: p.complete, w: "80px" },
              { badge: p.badge, w: "60px" },
            ]} />
          ))}
        </ContentCard>
        {/* Skills preview card */}
        <div style={{ margin: "0 12px", background: "#fff", borderRadius: "10px", boxShadow: "0 2px 10px rgba(0,0,0,0.07)", border: "1px solid #f0f0f0", padding: "10px 14px" }}>
          <div style={{ fontSize: "9px", fontWeight: 700, color: "#212121", marginBottom: "7px" }}>Top Skills — Full Stack Dev</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
            {["React", "Node.js", "TypeScript", "PostgreSQL", "Docker", "REST APIs"].map((s) => (
              <span key={s} style={{ background: "#e8f0fe", color: "#1a73e8", borderRadius: "6px", padding: "2px 8px", fontSize: "8px", fontWeight: 600 }}>{s}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  </BrowserFrame>
);

// ── CRM mock ──────────────────────────────────────────────────────────────────
const contacts = [
  { name: "Sarah Chen",  company: "Acme Corp",  tag: { bg: "#e8f0fe", c: "#1a73e8", label: "Client"   }, dot: "#1a73e8" },
  { name: "Marcus Webb", company: "Studio Inc", tag: { bg: "#e6f4ea", c: "#2e7d32", label: "Lead"     }, dot: "#34a853" },
  { name: "Anna Müller", company: "Freelance",  tag: { bg: "#e8f0fe", c: "#1a73e8", label: "Client"   }, dot: "#1a73e8" },
  { name: "Tom Fischer", company: "TechGmbH",   tag: { bg: "#fff8e1", c: "#f57c00", label: "Prospect" }, dot: "#fbbc04" },
  { name: "Lena Bauer",  company: "Bauer & Co", tag: { bg: "#e6f4ea", c: "#2e7d32", label: "Lead"     }, dot: "#34a853" },
];

export const MockCrmDashboard = () => (
  <BrowserFrame>
    <AppSidebar activeSection="crm" activeItem="Companies" />
    <div style={{ flex: 1, background: "#f5f7fa", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <TopBar title="Contacts" />
      <div style={{ flex: 1, overflow: "hidden" }}>
        <ContentCard title="Companies & People" action="+ New">
          <ColHeaders labels={[{ label: "Name" }, { label: "Company" }, { label: "Tag", w: "65px" }]} />
          {contacts.map((c, i) => (
            <Row key={i} even={i % 2 !== 0} cols={[
              { avatar: { letter: c.name[0], bg: c.dot, round: true }, text: c.name },
              { text: c.company, muted: true },
              { badge: c.tag, w: "65px" },
            ]} />
          ))}
        </ContentCard>
      </div>
    </div>
  </BrowserFrame>
);
